
import { defineComponent } from 'vue';
import { useController } from '@/domain/services/Composer';
import { videoThumbnailSelectorController } from './VideoThumbnailSelector.controller';

export default defineComponent({
	props: {
		thumbnails: {
			type: Array as () => string[],
			required: true,
		},
		value: {
			type: String,
			default: null,
		},
		fileToken: {
			type: String,
			required: true,
		},
	},
	emits: ['thumbnailSelected'],
	setup: useController(videoThumbnailSelectorController, 'videoThumbnailSelectorController'),
});
